import { render } from "./note_dtl.vue?vue&type=template&id=9241e67a"
import script from "./note_dtl.vue?vue&type=script&lang=js"
export * from "./note_dtl.vue?vue&type=script&lang=js"

import "./note_dtl.vue?vue&type=style&index=0&id=9241e67a&lang=css"

import exportComponent from "E:\\devops.aliyun\\liangting\\liangting_business_web\\seller.web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__